import { render, staticRenderFns } from "./CustomerActivities.vue?vue&type=template&id=559e02ff&scoped=true"
import script from "./CustomerActivities.vue?vue&type=script&lang=js"
export * from "./CustomerActivities.vue?vue&type=script&lang=js"
import style0 from "./CustomerActivities.vue?vue&type=style&index=0&id=559e02ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559e02ff",
  null
  
)

export default component.exports